import { observer } from 'mobx-react';
import * as React from 'react';
import { Draggable } from '@hello-pangea/dnd';
import LearningCollectionEditStore from '../../../../Store';
import { ModifiableExperiencesContext } from '../../../../../Types';
import CustomizeRow from './CustomizeRow';

interface Props {
  context: ModifiableExperiencesContext;
  store: LearningCollectionEditStore;
}

const Experiences: React.FC<Props> = ({ context, store }) =>
  store.experienceStores(context).map(({ experienceResource }, index) => (
    <Draggable
      index={index}
      key={experienceResource.payload.id}
      draggableId={String(experienceResource.payload.id)}
    >
      {(provided) => (
        <tr
          className="block align-top [&:not(:last-child)]:pb-4"
          ref={provided.innerRef}
          {...provided.draggableProps}
        >
          <CustomizeRow
            context={context}
            store={store}
            experienceResource={experienceResource}
            dragHandleProps={provided.dragHandleProps}
          />
        </tr>
      )}
    </Draggable>
  ));

export default observer(Experiences);
